import { useEffect, useRef } from 'react';

/**
 * 串行轮询：上一次请求结束后再等 delay；页面隐藏时跳过请求，回到前台继续。
 */
export function usePoll(callback, delay, enabled) {
    const callbackRef = useRef(callback);

    useEffect(() => {
        callbackRef.current = callback;
    });

    useEffect(() => {
        if (!enabled) return undefined;
        let stopped = false;
        let timer = null;

        const tick = async () => {
            if (stopped) return;
            if (document.visibilityState !== 'hidden') {
                try {
                    await callbackRef.current();
                } catch {
                    // 轮询失败不打断，下一轮继续
                }
            }
            if (!stopped) timer = setTimeout(tick, delay);
        };

        timer = setTimeout(tick, delay);
        return () => {
            stopped = true;
            clearTimeout(timer);
        };
    }, [delay, enabled]);
}
